import React, { FC } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../constants/aampeTheme';

// components
import BasicChip from '../display/chips/basicChip';

interface FormulaTagsViewProps {
    tags?: any[];
}

const FormulaTagsView: FC<React.PropsWithChildren<FormulaTagsViewProps>> = ({
    tags,
}) => {
    return (
        <Container>
            {!!tags?.length &&
                tags?.map((item) => (
                    <StyledBasicChip key={item.id} title={item.name} />
                ))}
            {!tags?.length && <StyledBasicChip title={'No tags yet'} />}
        </Container>
    );
};

export default FormulaTagsView;

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(1),
    flexWrap: 'wrap',
});

const StyledBasicChip = styled(BasicChip)({
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    backgroundColor: aampeTheme.colors.white,
    borderRadius: '16px',
    color: aampeTheme.colors.blue900,
    fontWeight: 400,
    lineHeight: '18px',
    fontSize: '14px',
});
